import reducer from './reducers'
import * as actions from './actions'
import Header from './components/Header'

import { rootSaga } from './sagas'

export { reducer, rootSaga, actions }
export default Header
